<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { actions, injectMixins } from '@/services'
import Cookies from 'js-cookie'
import { getHideParams, setHideParams } from '@/hide'
import { isWeixin, setupWXShare, appShare } from '@/helpers'

export default {
  name: 'App',

  mixins: [
    injectMixins
  ],

  created () {
    this.initURLVariable()
  },

  mounted () {
    this.buildRelation()
    this.$watch('httpErr', (errMsg) => {
      if (errMsg) {
        this.$toast.error(errMsg, 'top', {
          width: '80vw',
          time: 20000
        })
      }
    })
    // 趣味测评初始化
    this.interestInit()
  },

  methods: {
    // 趣味测评初始化
    async interestInit () {
      // 是否为趣味测评
      const url = location.href
      if (!url.includes('interest') || !isWeixin) {
        return
      }
      const ret = await actions.wxShareData(this.code)
      if (ret.code === 200) {
        const data = ret.data || {}
        // 微信分享初始化
        setupWXShare({
          wShareTitle: data.title,
          wShareDesc: data.desc,
          link: data.link,
          imgUrl: data.imgUrl,
          type: 'link',
          dataUrl: ''
        })
        // app分享
        appShare({
          title: data.title,
          url: data.link,
          thumb: data.imgUrl,
          description: data.desc
        })
      }
    },
    buildRelation () {
      const { refId, code, identity, babyId } = this.$route.query

      if (refId) {
        this.gActions.distributionRelation({ accountId: refId, cpCode: code, identity })
      }

      if (babyId) { // 来源APP档案
        this._setSessionCookie('yly_baby_id', babyId)
      }
    },

    _setSessionCookie (key, value) {
      console.debug('Cookie Set[', key, '', value, ']')

      Cookies.set(key, value, {
        path: '/',
        domain: '.doctopia.com.cn'
      })
    },

    // 通过URL隐藏相关按钮
    initURLVariable () {
      if (!getHideParams()) {
        const { hideRecommend, hideAsk, hideAgain } = this.$route.query
        this.gState.hide = {
          recommend: !!hideRecommend,
          again: !!hideAgain,
          askDoctor: !!hideAsk
        }
        setHideParams(this.gState.hide)
      }
    }
  },

  computed: {
    httpErr () {
      return this.gState.httpErr
    }
  }
}
</script>
